module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-right-square-fill-ffe6b826.svg";